__webpack_require__.p = "//static.hsappstatic.net/embedded-academy-ui/static-1.8189/";